export enum BANK_PARTNERS {
  Saison = 'saison',
  LiquiLoan = 'liqui_loan',
}
